import http from 'services/http-service';

const ProgramService = {
    GetFeatured() {
        var response = http.get("/programs/featured");
        return response;
    },

    GetProgramDiscover() {
        var response = http.get(`/programs/discover`);
        return response;
    },

    GetAllProgram() {
        var response = http.get(`/programs`);
        return response;
    },

    GetLibraries() {
        var response = http.get(`/programs/libraries`);
        return response;
    },

    GetProgram(id: string) {
        var response = http.get(`/programs/${id}`);
        return response;
    },

    GetProgramAdmin(id: string) {
        var response = http.get(`/programs/admin/${id}`);
        return response;
    },

    GetLessonGroup(programId: string, lessonGroupId: string) {
        var response = http.get(`/programs/${programId}/lessongroups/${lessonGroupId}`);
        return response;
    },

    GetLesson(programId: string, lessonId: string) {
        var response = http.get(`/programs/admin/${programId}/lessons/${lessonId}`);
        return response;
    },

    MarkAsComplete(programId: string, lessonId: string) {
        var response = http.put(`programs/markAsComplete`, { programId, lessonId });
        return response;
    },

    CreateNew(code: string, name: string, fullName: string, description: string, isFeaturedInHomePage: any, overview: string, priceOriginal: any, price: any, commisionFee: any, posterImage: any, authorId: any, umaiPrefixTag: string, pipelineId: string) {
        let formData = new FormData();
        formData.append("code", code);
        formData.append("name", name);
        formData.append("fullName", fullName);
        formData.append("description", description);
        formData.append("isFeaturedInHomePage", isFeaturedInHomePage);
        formData.append("overview", overview);
        formData.append("priceOriginal", priceOriginal);
        formData.append("price", price);
        formData.append("commisionFee", commisionFee);
        formData.append("posterImage", posterImage);
        formData.append("authorId", authorId);
        formData.append("umaiPrefixTag", umaiPrefixTag);
        formData.append("umaiPipelineId", pipelineId);

        var result = http.post("/programs", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
        return result;
    },

    Edit(programId: string, code: string, name: string, fullName: string, description: string, isFeaturedInHomePage: any, overview: string, priceOriginal: any, price: any, commisionFee: any, authorId: any, umaiPrefixTag: string, pipelineId: string) {
        var data = {
            programId: programId,
            code: code,
            name: name,
            fullName: fullName,
            description: description,
            isFeaturedInHomePage: isFeaturedInHomePage,
            overview: overview,
            priceOriginal: priceOriginal,
            price: price,
            commisionFee: commisionFee,
            authorId: authorId,
            umaiPrefixTag: umaiPrefixTag,
            umaiPipelineId: pipelineId
        }
        var response = http.put(`/programs/${programId}`, data);
        return response;
    },

    Copy(programId: string, code: string) {
        var response = http.post("programs/copy", { fromProgramId: programId, newCode: code });
        return response;
    },

    UploadVideoProgramPreviewChunk(programId: string, chunk: any, counter: any, fileName: string) {
        var response = http.post(`/programs/${programId}/uploadchunks`, chunk, {
            params: {
                id: counter,
                fileName: fileName,
            },
            headers: { 'Content-Type': 'application/json' }
        });
        return response;
    },

    UploadVideoProgramPreviewComplete(programId: string, chunkId: string, fileName: string, fileSize: number) {
        var response = http.post(`/programs/${programId}/uploadcomplete`, { fileName: chunkId, uploadedFileName: fileName, fileSize: fileSize });
        return response;
    },

    DeleteVideoProgramPreview(programId: string) {
        var response = http.delete(`/programs/${programId}/video`);
        return response;
    },

    GetProgramPreviewVideoUploadQueue(programId: string) {
        var response = http.get(`/programs/${programId}/videoupload`);
        return response;
    },

    Activate(programId: string) {
        var response = http.put(`/programs/${programId}/activate`);
        return response;
    },

    DeActivate(programId: string) {
        var response = http.put(`/programs/${programId}/deactivate`);
        return response;
    },

    ReUpdateProgramSubscription(programId: string) {
        var response = http.post(`/programs/${programId}/ReUpdateProgramSubscription`);
        return response;
    },

    ChangePosterImage(programId: string, imageData: any) {
        let formData = new FormData();
        formData.append("image", imageData);

        var result = http.put(`/programs/${programId}/changeposter`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
        return result;
    },

    AddLessonGroup(programId: any, title: string) {
        var response = http.post(`/programs/${programId}/lessongroups`, { title: title });
        return response;
    },

    EditLessonGroup(programId: string, lessonGroupId: string, title: string, sequence: number) {
        var response = http.put(`/programs/${programId}/lessongroups`, { lessonGroupId: lessonGroupId, title: title, sequence: sequence });
        return response;
    },

    DeleteLessonGroup(programId: string, lessonGroupId: string) {
        var response = http.delete(`/programs/${programId}/lessongroups/${lessonGroupId}`);
        return response;
    },

    AddLesson(programId: string, lessonGroupId: string, title: string, subTitle: string, description: string, isAllowForPublic: any, posterImage: any) {
        let formData = new FormData();
        formData.append("title", title);
        formData.append("subTitle", subTitle);
        formData.append("posterImage", posterImage);
        formData.append("description", description);
        formData.append("isAllowForPublic", isAllowForPublic);

        var result = http.post(`/programs/${programId}/lessongroups/${lessonGroupId}/lessons/new`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
        return result;
    },

    UpdateLesson(programId: string, lessonGroupId: string, lessonId: string, title: string, subTitle: string, description: string, isAllowForPublic: boolean, sequence: any) {
        var response = http.put(`/programs/${programId}/lessongroups/${lessonGroupId}/lessons/${lessonId}`, {
            title: title,
            subTitle: subTitle,
            description: description,
            isAllowForPublic: isAllowForPublic,
            sequence: sequence
        });
        return response;
    },

    MoveLessonGroup(programId: string, lessonGroupId: string, lessonId: string, newLessonGroupId: string) {
        var response = http.put(`/programs/${programId}/lessongroups/${lessonGroupId}/lessons/${lessonId}/movegroup`, {
            newLessonGroupId: newLessonGroupId
        });
        return response;
    },

    DeleteLesson(programId: string, lessonGroupId: string, lessonId: string) {
        var response = http.delete(`/programs/${programId}/lessongroups/${lessonGroupId}/lessons/${lessonId}`);
        return response;
    },

    ChangeLessonPosterImage(programId: string, lessonGroupId: string, lessonId: string, imageData: any) {
        let formData = new FormData();
        formData.append("image", imageData);

        var result = http.put(`/programs/${programId}/lessongroups/${lessonGroupId}/lessons/${lessonId}/changeposter`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
        return result;
    },

    UploadVideoLessonChunk(programId: string, lessonGroupId: string, lessonId: string, chunk: any, counter: any, fileName: string) {
        var response = http.post(`/programs/${programId}/lessongroups/${lessonGroupId}/lessons/${lessonId}/uploadchunks`, chunk, {
            params: {
                id: counter,
                fileName: fileName,
            },
            headers: { 'Content-Type': 'application/json' }
        });
        return response;
    },

    UploadVideoLessonComplete(programId: string, lessonGroupId: string, lessonId: string, chunkId: string, fileName: string, fileSize: number) {
        var response = http.post(`/programs/${programId}/lessongroups/${lessonGroupId}/lessons/${lessonId}/uploadcomplete`, { fileName: chunkId, uploadedFileName: fileName, fileSize: fileSize });
        return response;
    },

    GetLessonVideoUploadQueue(programId: string, lessonGroupId: string, lessonId: string) {
        var response = http.get(`/programs/${programId}/lessongroups/${lessonGroupId}/lessons/${lessonId}/videoupload`);
        return response;
    },

    DeleteVideoLesson(programId: string, lessonGroupId: string, lessonId: string) {
        var response = http.delete(`/programs/${programId}/lessongroups/${lessonGroupId}/lessons/${lessonId}/video`);
        return response;
    },

    ActivateLesson(programId: string, lessonGroupId: string, lessonId: string) {
        var response = http.put(`/programs/${programId}/lessongroups/${lessonGroupId}/lessons/${lessonId}/activate`);
        return response;
    },

    DeActivateLesson(programId: string, lessonGroupId: string, lessonId: string) {
        var response = http.put(`/programs/${programId}/lessongroups/${lessonGroupId}/lessons/${lessonId}/deactivate`);
        return response;
    },

    AddLessonResource(programId: string, lessonGroupId: string, lessonId: string, name: string, description: string, author: string, resourceType: any, posterImage: any, resourceFile: any) {
        let formData = new FormData();
        formData.append("name", name);
        formData.append("description", description);
        formData.append("author", author);
        formData.append("resourceType", resourceType);
        formData.append("posterImage", posterImage);
        formData.append("resourceFile", resourceFile);

        var result = http.post(`/programs/${programId}/lessongroups/${lessonGroupId}/lessons/${lessonId}/resources`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });

        return result;
    },

    DeleteLessonResource(programId: string, lessonGroupId: string, lessonId: string, resourceId: string) {
        var response = http.delete(`/programs/${programId}/lessongroups/${lessonGroupId}/lessons/${lessonId}/resources/${resourceId}`);
        return response;
    },

    ActivateSubscription(userId: number, programId: string) {
        var response = http.post(`/programs/${programId}/activateSubscription`, { userId: userId, programId: programId });
        return response;
    },

    DeActivateSubscription(userId: number, programId: string) {
        var response = http.post(`/programs/${programId}/deActivateSubscription`, { userId: userId, programId: programId });
        return response;
    }
};

export default ProgramService;